

















import Vue from 'vue';
import Component from 'vue-class-component';
import Pano from '@/components/panolens.vue';
import {Prop} from 'vue-property-decorator';
import {Base64} from 'js-base64';

import '@/globals';

@Component({
    components: {
        Pano,
    },
})
export default class VideoPlayerPage extends Vue {

    @Prop(String) public panoramaUrlEncoded: string;

    get panoramaUrl() {
        return Base64.decode(this.panoramaUrlEncoded);
    }
}
